<template>
  <div>
    <div class="page-title-box">
      <h4 class="page-title">Klassifikaatorite haldus</h4>
    </div>

    <div class="card" v-for="label in Object.keys(classifiers)">
      <div class="card-body">
        <h4 class="header-title" @click="toggleContentFor(label)" style="cursor: pointer">
          {{label}}
          <i class="float-right mdi" style="line-height: .8em; font-size: 150%"
             :class="{'mdi-chevron-right': !shouldShowContent(label), 'mdi-chevron-left': shouldShowContent(label)}"></i>
        </h4>
        <div class="row" :style="{'display': !shouldShowContent(label) ? 'none' : ''}">
          <div class="col-lg-12">
            <a href="#" class="card-link text-primary float-right" @click="addClassifier(label, classifiers[label][0].classifier)">
              <i class="mdi mdi-plus"></i> Lisa uus klassifikaator
            </a>
          </div>
        </div>
        <div class="row" v-if="shouldShowContent(label)">

          <table class="table table-sm table-centered table-sticky table-hover mb-0">
            <thead>
            <tr>
              <th>Nimetus eesti keeles</th>
              <th>Nimetus inglise keeles</th>
              <th>Väärtus</th>
              <th>Alamkategooria</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="classifier in classifiers[label]">
              <td>{{classifier.titleEst}}</td>
              <td>{{classifier.titleEng}}</td>
              <td>{{classifier.value}}</td>
              <td>{{classifier.parent}}</td>
              <td>
                <permission name="ClassifierRemove">
                  <button type="button" class="btn btn-link btn-sm float-right">
                    <i class="mdi mdi-delete" @click="deleteClassifier(classifier)"></i>
                  </button>
                </permission>
                <permission name="ClassifierUpdate">
                  <button type="button" class="btn btn-link btn-sm float-right">
                    <i class="mdi mdi-pencil" @click="updateClassifier(classifier)"></i>
                  </button>
                </permission>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>

    <modal ref="addClassifierModal" title="Lisa klassifikaator" size="lg" @ok="loadClassifiers">
      <add-classifier :params="data" slot-scope="{close, visible, data}" @done="close" v-if="visible"/>
    </modal>

    <modal ref="updateClassifierModal" title="Muuda klassifikaatorit" size="lg" @ok="loadClassifiers">
      <update-classifier :classifier="data" slot-scope="{close, visible, data}" @done="close" v-if="visible"/>
    </modal>

  </div>
</template>

<script>
  import Modal from '@/components/Modal'
  import AddClassifier from '@/components/classifier/AddClassifier'
  import UpdateClassifier from '@/components/classifier/UpdateClassifier'

  export default {
    components: {Modal, AddClassifier, UpdateClassifier},
    data() {
      return {
        active: [],
        classifiers: {}
      }
    },
    methods: {
      loadClassifiers() {
        this.$gateway.get('/admin/classifiers').then(r => {
          return this.classifiers = r.data;
        })
      },

      toggleContentFor(label) {
        if(this.active.includes(label)) {
          this.active = this.active.filter(e => e !== label)
        } else {
          this.active = this.active.concat(label)
        }
      },

      shouldShowContent(label) {
        return this.active.includes(label);
      },

      addClassifier(label, key) {
        this.$refs.addClassifierModal.show({label, key})
      },

      updateClassifier(classifier) {
        this.$refs.updateClassifierModal.show(classifier)
      },

      deleteClassifier(classifier) {
        this.$confirm("Olete kindel, et soovite klassifikaatori kustutada?", () => {
          this.$gateway.post('/admin/classifiers/delete', classifier).then(() => {
            this.$notifications.info(`Klassifikaator on kustutatud`)
            this.loadClassifiers()
          });
        })
      }
    },
    created() {
      this.loadClassifiers()
    }
  }
</script>
